import { QueryClient } from 'react-query';
import { IPipelinesService } from '../../../../core/modules/pipelines/pipelines.service';
import { AzureMLKey, DurableApp } from '../../../../core/modules/pipelines/pipelines.model';
import { PIPELINE_QUERY_OPTIONS } from '../../../../core/modules/pipelines/hooks/usePipelinesQueryConfig';

/** Default history counts per detail hook (must match useXPipeline). */
const HISTORY = {
  azureml: 10,
  durable: 50,
  function: 50
} as const;

export const prefetchPipelineDetail = (
  pipelineId: string,
  queryClient: QueryClient,
  service: IPipelinesService
): void => {
  if (pipelineId.startsWith('azureml.')) {
    const key = pipelineId.split('.')[1] as AzureMLKey;
    const history = HISTORY.azureml;

    queryClient.prefetchQuery(
      ['pipelines', 'azureml', key, history],
      () => service.getAzureMLPipeline(key, history),
      PIPELINE_QUERY_OPTIONS
    );

    return;
  }

  if (pipelineId.startsWith('durable.')) {
    // ID shape: durable.<app>.<orchestrator_with_underscores>
    const [, app, ...rest] = pipelineId.split('.');
    const orchestrator = rest.join('.').replace(/_/g, '-');
    const history = HISTORY.durable;

    queryClient.prefetchQuery(
      ['pipelines', 'durable', app as DurableApp, orchestrator, history],
      () => service.getDurablePipeline(app as DurableApp, orchestrator, history),
      PIPELINE_QUERY_OPTIONS
    );

    return;
  }

  if (pipelineId.startsWith('function.')) {
    const history = HISTORY.function;

    queryClient.prefetchQuery(
      ['pipelines', 'function', pipelineId, history],
      () => service.getFunctionPipeline(pipelineId, history),
      PIPELINE_QUERY_OPTIONS
    );
  }

  // timer.* skipped — already primed by the overview poll.
};
